// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorMessage_root__4CLAr","title":"ErrorMessage_title__3YSUk","message":"ErrorMessage_message__2jK8x"};